module.exports = __webpack_public_path__ + "img/video4.d5b65f74.jpg";